const CustomButton = ({ item, onClick }) => {
  const count = item.codes?.length ?? 0

  const format = () => {
    const visibleCodes = item.codes.slice(0, 3)
    const remainingCount = item.codes.length - visibleCodes.length

    if (count > 3) return `${visibleCodes.join(", ")} 외 ${remainingCount} 개`
    if (count > 0) return `${item.codes.join(", ")}`
    return "신규 등록"
  }

  return (
    <button
      type="button"
      className="
        group
        flex w-full items-center justify-between
        rounded
        text-left
        transition-colors
        cursor-pointer
      "
      onClick={onClick}
    >
      <span
        className="text-gray-700 
      group-hover:underline "
      >
        {format()}
      </span>
    </button>
  )
}

export default CustomButton
